import { render, staticRenderFns } from "./OverviewIndex.vue?vue&type=template&id=dc44c2ee&scoped=true"
import script from "./OverviewIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OverviewIndex.vue?vue&type=style&index=0&id=dc44c2ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc44c2ee",
  null
  
)

export default component.exports